import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import { ARTICLES, CATEGORIES } from "../../data/learningArticles";
import { useDocMeta } from "../../lib/useDocMeta";

/**
 * Customer Learning view — same content as the public /learning hub,
 * but framed inside the customer shell. Links point at the public
 * article pages so the underlying article URLs remain shareable.
 */
export default function CustomerLearning() {
  useDocMeta({ title: "Learning · GovBidIQ", path: "/app/learning" });
  return (
    <div className="space-y-6 max-w-[1100px]" data-testid="cust-learning">
      <header>
        <div className="tick-label text-sky-400 mb-1">/ Learning</div>
        <h1 className="font-display font-black text-3xl text-slate-100 inline-flex items-center gap-2">
          <BookOpen className="w-6 h-6 text-sky-400" /> Learning Hub
        </h1>
        <p className="text-slate-400 text-sm mt-1 max-w-2xl">
          Curated capture, compliance, and proposal fundamentals — same content as our public Academy, available to you inside the platform.
        </p>
      </header>

      {CATEGORIES.map((cat) => {
        const items = ARTICLES.filter((a) => a.category === cat);
        if (!items.length) return null;
        return (
          <section key={cat} className="border border-[var(--border-soft)] bg-[var(--bg-secondary)] p-4">
            <div className="tick-label text-sky-400 mb-3">/ {cat}</div>
            <ul className="grid sm:grid-cols-2 gap-2">
              {items.slice(0, 8).map((a) => (
                <li key={a.slug}>
                  <Link to={`/learning/${a.slug}`} data-testid={`cust-learning-article-${a.slug}`} className="block px-3 py-2 hover:bg-slate-900/70 border border-transparent hover:border-sky-500/30">
                    <div className="text-slate-100 text-sm font-display font-bold inline-flex items-center gap-1.5">{a.title} <ArrowRight className="w-3 h-3 text-sky-400" /></div>
                    <div className="text-[11px] text-slate-500 mt-0.5 leading-snug line-clamp-2">{a.summary}</div>
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        );
      })}
    </div>
  );
}
